import request from '../util/request';
import SERVER_URL from '../util/seaver';

// 企业查询
function enterpriseSel(reqData) {
  const reqUrl = SERVER_URL + '/enterprise/sel';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function enterpriseAdd(reqData) {
  const reqUrl = SERVER_URL + '/enterprise/add';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function enterpriseDel(reqData) {
  const reqUrl = SERVER_URL + '/enterprise/del';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function enterpriseMod(reqData) {
  const reqUrl = SERVER_URL + '/enterprise/mod';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function enterpriseCount(reqData) {
  const reqUrl = SERVER_URL + '/enterprise/count';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
export { enterpriseSel, enterpriseAdd, enterpriseDel, enterpriseMod, enterpriseCount };
